/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import PreviewImage from 'DesignSystem/PreviewImage/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/ImageComparison/Content/Actions/Choose/ChooseImageAction/Content/Content/Images/Content/PatientImage/Content"
  
}) {
let resourceObjectMetaUrlValueData = fromData.useDataValue({ viewPath,
context: 'resource_object_meta',
path: 'url',
})
let comparisonActionImageIdValueData = fromData.useDataValue({ viewPath,
context: 'comparison_action',
path: 'image_id',
})
let patientImageIdValueData = fromData.useDataValue({ viewPath,
context: 'patient_image',
path: 'id',
})
let aggregateData = fromAggregate.equals(comparisonActionImageIdValueData, patientImageIdValueData)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<PreviewImage
  viewPath={`${viewPath}/PreviewImage`}
 data="resource_object_meta.url"
 url={resourceObjectMetaUrlValueData}
 onClick={onClick}
 marginLeft={dtSpaceXs}
 marginBottom={dtSpaceXs}
 opacity={aggregateData ? 1 : 0.6}
 data="comparison_action.image_id"
 data="patient_image.id"
 aggregate="/Data/aggregate.js equals"
/>
{children}
</React.Fragment>)
}